<template v-if="info">
  <div class="pro-icon-info">
    <div class="info-body">
      <p>{{ info }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: String
    }
  }
}
</script>
